import { apiSlice } from "./apiSlice";
import { baseURL } from "../../constant";
import {
  addCategory,
  createFiles,
  deleteCategory,
  deleteFile,
  getDocTypes,
  getFile,
  getFiles,
  setDocumentCategoriesSelection,
  setDocumentSubCategoriesSelection,
  updateCategory,
  updateComplianceFile,
  updateFile,
  updateFileApproval,
  updateFileStatus,
  updateFileV2,
  updateMultiFileStatus,
} from "../slice/fileSlice";
import { setReminders, updateReminderList } from "../slice/complianceSlice";

export const filesApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    approveDocument: builder.mutation({
      query: ({ id }) => ({
        url: `/api_docdigit/document/${id}/approve_document/`,
        method: "PATCH",
      }),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(updateFileStatus(result.data.data)))
          .catch(error => { });
      },
    }),
    approveMultiDocuments: builder.mutation({
      query: data => ({
        url: `/api_docdigit/document/approve_multi_documents/`,
        method: "PATCH",
        body: data,
      }),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(updateMultiFileStatus(result.data)))
          .catch(error => { });
      },
    }),
    createDocReplacement: builder.mutation({
      query: data => ({
        url: "/api_docdigit/document/upload_partner_compliance_replacement/",
        method: "post",
        body: data,
      }),
    }),
    createCategory: builder.mutation({
      query: data => ({ url: "/api_docdigit/document_category/", method: "post", body: data }),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(addCategory(result.data))).catch(error => { });
      },
    }),
    createSubCategory: builder.mutation({
      query: data => ({ url: "/api_docdigit/document_sub_category/", method: "post", body: data }),
    }),
    createFiles: builder.mutation({
      query: data => ({ url: "/api_docdigit/document/create_file/", method: "post", body: data }),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(createFiles(result.data))).catch(error => { });
      },
    }),
    createFilesAutomatic: builder.mutation({
      query: data => ({
        url: "/api_docdigit/document/create_file_automatic/",
        method: "post",
        body: data,
      }),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(createFiles(result.data))).catch(error => { });
      },
    }),
    createReminderOption: builder.mutation({
      query: data => ({ url: "/api_docdigit/reminder_types/", method: "post", body: data }),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(updateReminderList(result.data))).catch(error => { });
      },
    }),
    deleteCategory: builder.mutation({
      query: ({ id }) => ({ url: `/api_docdigit/document_category/${id}/`, method: "DELETE" }),
      onQueryStarted: (params, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(deleteCategory(params.id))).catch(error => { });
      },
    }),
    deleteSubCategory: builder.mutation({
      query: ({ id }) => ({ url: `/api_docdigit/document_sub_category/${id}/`, method: "DELETE" }),
    }),
    deleteFile: builder.mutation({
      query: ({ id }) => ({ url: `/api_docdigit/document/${id}/`, method: "DELETE" }),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(deleteFile(result.data))).catch(error => { });
      },
    }),
    deleteFiles: builder.mutation({
      query: data => ({ url: `/api_docdigit/document/delete_files/`, method: "PATCH", body: data }),
    }),
    deleteInModuleFile: builder.mutation({
      query: ({ id }) => ({ url: `/api_docdigit/document/${id}/`, method: "DELETE" }),
    }),
    getDocTypes: builder.query({
      query: params =>
        params ? `/api_docdigit/documnt_types/?${params}` : "/api_docdigit/documnt_types/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(getDocTypes(result.data))).catch(error => { });
      },
    }),
    getDocumentCategories: builder.query({
      query: params =>
        params ? `/api_docdigit/document_category/?&${params}` : "/api_docdigit/document_category/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(setDocumentCategoriesSelection(result.data)))
          .catch(error => { });
      },
    }),
    getDocumentSubCategories: builder.query({
      query: params =>
        params
          ? `/api_docdigit/document_sub_category/?${params}`
          : "/api_docdigit/document_sub_category/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(setDocumentSubCategoriesSelection(result.data)))
          .catch(error => { });
      },
    }),
    getDocumentCategoriesSelection: builder.query({
      query: params =>
        params
          ? `/api_docdigit/document_category/selection/?&${params}`
          : "/api_docdigit/document_category/selection/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(setDocumentCategoriesSelection(result.data)))
          .catch(error => { });
      },
    }),
    getDocumentSubCategoriesSelection: builder.query({
      query: params =>
        params
          ? `/api_docdigit/document_sub_category/selection/?${params}`
          : "/api_docdigit/document_sub_category/selection/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(setDocumentSubCategoriesSelection(result.data)))
          .catch(error => { });
      },
    }),
    getFile: builder.query({
      query: ({ id, params = null }) =>
        params ? `/api_docdigit/document/${id}/?${params}` : `/api_docdigit/document/${id}/`,
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(getFile(result.data))).catch(error => { });
      },
    }),
    getFiles: builder.query({
      query: params => (params ? `/api_docdigit/document/?${params}` : "/api_docdigit/document/"),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(getFiles(result.data))).catch(error => { });
      },
    }),
    getReminders: builder.query({
      query: () => `/api_docdigit/reminder_types/`,
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(setReminders(result.data))).catch(error => { });
      },
    }),
    sendReminder: builder.mutation({
      query: data => ({ url: "/api_docdigit/document_invite/", method: "post", body: data }),
    }),
    shareDirectMail: builder.mutation({
      query: data => ({ url: "api_docdigit/direct_file/", method: "POST", body: data }),
    }),
    shareRecordFiles: builder.mutation({
      query: data => ({
        url: "/api_docdigit/document/share/",
        method: "POST",
        body: data,
      }),
    }),
    bulkDownloadFiles: builder.mutation({
      async queryFn(ids) {
        try {
          const response = await fetch(`${baseURL}/api_docdigit/document/bulk_download/`, {
            method: "POST",
            credentials: "include",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ ids }),
          });
          if (!response.ok) {
            const errorBody = await response.json().catch(() => ({ detail: "Download failed." }));
            return { error: { status: response.status, data: errorBody } };
          }
          const contentType = response.headers.get("content-type") || "";
          if (contentType.includes("application/json")) {
            const data = await response.json();
            return { data: { mode: "individual", files: data.files } };
          }
          const blob = await response.blob();
          return { data: { mode: "zip", blob } };
        } catch (error) {
          return { error: { status: "FETCH_ERROR", error: String(error) } };
        }
      },
    }),
    updateApproval: builder.mutation({
      query: ({ id, data }) => ({
        url: `/api_docdigit/document/${id}/update_approval/`,
        method: "PATCH",
        body: data,
      }),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(updateFileApproval(result.data))).catch(error => { });
      },
    }),
    updateComplianceFile: builder.mutation({
      query: ({ id, data }) => ({
        url: `/api_docdigit/document/${id}/update_compliance_file/`,
        method: "PATCH",
        body: data,
      }),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(updateComplianceFile(result.data)))
          .catch(error => { });
      },
    }),
    updateCategory: builder.mutation({
      query: ({ id, data }) => ({
        url: `/api_docdigit/document_category/${id}/`,
        method: "PATCH",
        body: data,
      }),
      onQueryStarted: (params, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(updateCategory({ ...result.data, id: params.id }))).catch(error => { });
      },
    }),
    updateSubCategory: builder.mutation({
      query: ({ id, data }) => ({
        url: `/api_docdigit/document_sub_category/${id}/`,
        method: "PATCH",
        body: data,
      }),
    }),
    updateFile: builder.mutation({
      query: ({ id, data }) => ({
        url: `/api_docdigit/document/${id}/update_file/`,
        method: "PATCH",
        body: data,
      }),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(updateFile(result.data))).catch(error => { });
      },
    }),
    updateFileInModule: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/api_docdigit/document/${id}/update_file_in_module/`,
        method: "PATCH",
        body: data,
      }),
    }),
    updateFileRecipients: builder.mutation({
      query: data => ({ url: `/api_docdigit/modify_recipients/`, method: "PATCH", body: data }),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(updateFileV2(result.data))).catch(error => { });
      },
    }),
    updateFileReminder: builder.mutation({
      query: data => ({ url: `/api_docdigit/modify_reminder/`, method: "PATCH", body: data }),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(updateFileV2(result.data))).catch(error => { });
      },
    }),
    updateReminderOption: builder.mutation({
      query: data => ({
        url: "/api_docdigit/reminder_types/update_alert/",
        method: "post",
        body: data,
      }),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(setReminders(result.data.data))).catch(error => { });
      },
    }),
    validateDocToken: builder.query({ query: token => `/api_docdigit/validate_token/${token}/` }),
  }),
});

export const {
  useApproveDocumentMutation,
  useApproveMultiDocumentsMutation,
  useCreateDocReplacementMutation,
  useCreateCategoryMutation,
  useCreateSubCategoryMutation,
  useCreateFilesAutomaticMutation,
  useCreateFilesMutation,
  useCreateReminderOptionMutation,
  useDeleteCategoryMutation,
  useDeleteSubCategoryMutation,
  useDeleteFileMutation,
  useDeleteFilesMutation,
  useDeleteInModuleFileMutation,
  useGetDocTypesQuery,
  useGetDocumentCategoriesQuery,
  useGetDocumentSubCategoriesQuery,
  useGetDocumentCategoriesSelectionQuery,
  useGetDocumentSubCategoriesSelectionQuery,
  useLazyGetDocumentCategoriesSelectionQuery,
  useLazyGetDocumentSubCategoriesSelectionQuery,
  useGetFilesQuery,
  useGetRemindersQuery,
  useLazyGetDocumentCategoriesQuery,
  useLazyGetDocumentSubCategoriesQuery,
  useLazyGetFileQuery,
  useLazyValidateDocTokenQuery,
  useSendReminderMutation,
  useShareDirectMailMutation,
  useShareRecordFilesMutation,
  useBulkDownloadFilesMutation,
  useUpdateApprovalMutation,
  useUpdateComplianceFileMutation,
  useUpdateFileInModuleMutation,
  useUpdateCategoryMutation,
  useUpdateSubCategoryMutation,
  useUpdateFileMutation,
  useUpdateFileRecipientsMutation,
  useUpdateFileReminderMutation,
  useUpdateReminderOptionMutation,
} = filesApiSlice;
